import { useCallback, useEffect, useState } from 'react';
import { FloatingActions, Footer, Header } from './components/Layout';
import { NAV_ROUTES } from './data/siteData';
import { NotFoundPage, PAGES } from './routes';
import './App.css';

function getPath() {
  const hashPath = window.location.hash.replace('#', '') || '/';
  const knownPaths = [...NAV_ROUTES.map((route) => route.path), '/privacy-policy'];
  return knownPaths.includes(hashPath) ? hashPath : '/not-found';
}

export default function App() {
  const [path, setPath] = useState(getPath);

  const navigate = useCallback((nextPath) => {
    window.location.hash = nextPath;
    setPath(nextPath);
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 10);
  }, []);

  useEffect(() => {
    const handler = () => setPath(getPath());
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);

  const Page = PAGES[path] || NotFoundPage;

  return (
    <div className="site-shell">
      <Header activePath={path} onNavigate={navigate} />
      <main>
        <Page onNavigate={navigate} />
      </main>
      <Footer onNavigate={navigate} />
      <FloatingActions />
    </div>
  );
}
